import { render, staticRenderFns } from "./BaseROInputInline.vue?vue&type=template&id=72005c86&scoped=true"
import script from "./BaseROInputInline.vue?vue&type=script&lang=js"
export * from "./BaseROInputInline.vue?vue&type=script&lang=js"
import style0 from "./BaseROInputInline.vue?vue&type=style&index=0&id=72005c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72005c86",
  null
  
)

export default component.exports